import {
  branchBasedFeedbackDataFilter,
  getActiveBranchIds,
  getBranchInfobyId,
  getFirstActiveBranch,
} from "./multipleBranch/getActiveBranchId";

export function genPieChartData1(data) {
  // console.log(data);
  // console.log("raw data for pie chart sllllllllllllllllllllllllllllll");
  // console.log(getActiveBranchIds());
  const bId = getFirstActiveBranch()?.bId;
  // console.log(bId);
  if (bId == undefined || bId == null) return null;

  const qdata = JSON.parse(localStorage.getItem("questions"));
  // console.log(qdata);
  // console.log(data);
  if (data == null || qdata == null || data.length == 0) return null;

  return pieDataGenerator21(data, qdata);
}

function pieDataGenerator21(data, qdata) {
  // data is feedback data and qdata is questions set in feedback form
  // forat of output data
  /**
     FOrmate of object we want for pie chart 
     ArrForEachOptionQuestion = 
            [
                {
                quesitonTitle : "How was the Food",
                dataForBranch : [
                            {branchName : GK,
                             options :[
                                     {optionTitle:"Excellent",count:4},
                                     {optionTitle:"Goode",count:4},
                                     {optionTitle:"Ok-Ok",count:4},
                                     {optionTitle:"Poor",count:4}           
                                      ]
                             },{
                             branchName : "Lajpat nagar"
                             .....
                             }            
                ]
                }
            ]
     */

  // console.log(data);
  // STEP 1 . GRABBING only question from qdata
  let questionsString = [];
  questionsString = qdata?.optionQuestions.map((item) => {
    return item.title;
  });

  //Step 2. Finding how many branches activce and their ids.
  let activeBranches = getActiveBranchIds(
    JSON.parse(localStorage.getItem("branches"))
  );
  // console.log("active branches");
  // console.log(activeBranches);
  //Starting creating required Object.
  let pData = questionsString.map((question, qIndex) => {
    let objForOneQuestion = {
      questionTitle: question,
      dataForBranch: [],
    };

    const arrayOfBranches = activeBranches.map((bId) => {
      let branchName = getBranchInfobyId(bId).name;
      let optionsValue = calculateCountFrequencyForOneQuestionPieChart(
        data,
        qdata,
        qIndex,
        bId
      );
      let objForOneBranch = {
        branchName: branchName,
        options: optionsValue,
      };
      return objForOneBranch;
    });
    objForOneQuestion.dataForBranch = arrayOfBranches;
    return objForOneQuestion;
  });

  return pData;
}

function calculateCountFrequencyForOneQuestionPieChart(
  data,
  qdata,
  qIndex,
  bId
) {
  //Example of how we are populating chartArray.
  /**
   *   [
     {
    questionTitle: "How was the Food",
    
    options  : [ 
      {optionTitle: 'Excellent', count: 6},
      {optionTitle: 'Good', count: 5},
      {optionTitle: 'ok-ok', count: 4}
    
    ]
  } */

  const data1 = branchBasedFeedbackDataFilter(data, bId);
  //console.log(data1);
  let q = qdata.optionQuestions[qIndex];
  let chartQuestion = {
    questionTitle: q.title,
    options: [],
  };

  q.options.forEach((element) => {
    let optObj = {};
    optObj.optionTitle = element;
    optObj.count = 0;
    chartQuestion.options.push(optObj);
  });

  data1?.forEach((data) => {
    data.data?.optionQuestions.forEach((item) => {
      if (item.title == chartQuestion.questionTitle) {
        chartQuestion.options.forEach((i) => {
          //  console.log(i);
          if (i.optionTitle == item.answer) {
            i.count += 1;
          }
        });
      }
    });
  });

  return chartQuestion;
}

export function pieChartPercentageCalculator1(data) {
  /*
  format of data - {quesitonTitle, options:[{optionTitle, count},{}]}
  */
  //console.log(data);
  if (data == null) return null;
  let totalCount = 0;
  data.options.forEach((item) => {
    totalCount += item.count;
  });
  // console.log(totalCount);
  const output = [];
  data.options.forEach((item, index) => {
    let obj = { optionTitle: "", percentage: " %" };
    obj.optionTitle = item.optionTitle;
    let p = (item.count * 100) / totalCount;
    p = Math.round(p * 100) / 100;

    obj.percentage = p;
    output.push(obj);
  });

  return output;
}
